
import { Avatar, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { LayoutCrearDoc, LayoutTabla } from "../../layouts";
import { CargandoMedio, MensajeAlertaDanger, ModalFormulario, TooltipAndIcon } from "../../components";
import { useModalStore } from "../../../stores";
import { FormCreatUpdateSlide } from "../components";
import { useSlideShowHomePrincipal } from "../../../hooks/cache";
import { eliminarSlideShow } from "../../../services";
import { useQueryClient } from "@tanstack/react-query";



import Swal from "sweetalert2";
const baseUrl = process.env.REACT_APP_API_URL;



export const ConfiguracionSlideShow = () => {


    const queryClient = useQueryClient();
    const { modalFormToggle } = useModalStore();
    const { data, isLoading } = useSlideShowHomePrincipal();
    


    const handleEliminar = async(slide) => {
        const { isConfirmed  } = await Swal.fire({
            title: 'Eliminar Imagen Publicitaria',
            text: `¿Esta seguro de eliminar esta imagen?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Obvio Si' 
        });

        if( !isConfirmed  ) return;

        const resp = await eliminarSlideShow(slide);
        if( resp ){
            queryClient.invalidateQueries({ queryKey: ['slideshow-principal'] });
        }
    }



    return (
        <LayoutCrearDoc titulo='Listado de SlideShow' subtitulo='Ajustes de Imagenes' funcion={() => modalFormToggle(true)}>
            {(isLoading)
            ?   <CargandoMedio titulo="Cargando información de imagenes publicitarias..." />

            :   <>
                {(data?.length > 0)
                ?   <LayoutTabla mt={3}>
                        <TableHead >
                            <TableRow>
                                <TableCell sx={{width:'25%'}}>Imagen</TableCell>
                                <TableCell sx={{width:'45%'}}>Titulo</TableCell>
                                <TableCell sx={{width:'20%'}}>Acciones</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.map( (c) => (
                            <TableRow key={ c.id }>
                                <TableCell sx={{ display:'flex', justifyContent:'center' }}>
                                    <Avatar src={`${baseUrl}/uploads/slideshow/${ c.img }`} 
                                        alt="Imagen Publicitaria" sx={{ width: 60, height: 60 }}
                                    /> 
                                </TableCell>
                                <TableCell>{ c.titulo }</TableCell>
                                <TableCell>
                                    <TooltipAndIcon
                                        titulo="Eliminar Imagen"
                                        icono="eliminar"
                                        color="red"
                                        onClick={ () => handleEliminar(c.id) }
                                    />  
                                </TableCell>
                            </TableRow>
                            ))
                            }
                        </TableBody>
                    </LayoutTabla>

                :   <MensajeAlertaDanger titulo='No hay información disponibles' />
                }
                </>
            }


            <ModalFormulario titulo="Crear Imagen Publicidad" valor={{}} onClose={() => modalFormToggle(false)}>
                <FormCreatUpdateSlide />
            </ModalFormulario>
        </LayoutCrearDoc>
        
    )
}
